import createRoute       from '@widesk-ui/tools/createRoute';

export default createRoute.custom('Liste des mails', '/mails/:service/', 'MailTable');